import React, { useEffect } from 'react'
import { CashboosterList } from './list/page'
import { $cashBoosterMonth, cashBoosterMonthMounted } from './list/model'
import { useStore } from 'effector-react'

export const CashBoosterPage: React.FC = () => {
  const cashBoosterMonth = useStore($cashBoosterMonth)

  useEffect(() => {
    cashBoosterMonthMounted()
  }, [])

  return (
    cashBoosterMonth && (
      <CashboosterList
        year={new Date().getFullYear()}
        month={new Date().getMonth() + 1}
      />
    )
  )
}
